import { lazy, Suspense } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';
import ForgotPasswordPage from 'src/pages/Auth/forgotPassword';
import LoginPage from 'src/pages/Auth/Login';
import OTPVerificationPage from 'src/pages/Auth/otpVerification';
import ResetPasswordPage from 'src/pages/Auth/resetPassword';
import VendorRegistration from 'src/pages/Auth/VendorRegistration';

// Loader defined with suspense for lazy loading
const Loader = (Component) => {
  const WrappedComponent = (props) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

  // Set displayName for better debugging
  WrappedComponent.displayName = `Loader(${
    Component.displayName || Component.name
  })`;

  return WrappedComponent;
};

// Importing components
const Login = Loader(lazy(() => import('src/authentications/BidPortal/index')));

// Public routing component
export const publicRoutes = [
  {
    path: '/:state/:township/:uuid',
    element: <Login />
  },
  {
    path: '/:state/:township/:uuid/login',
    element: <LoginPage />
  },
  {
    path: '/:state/:township/:uuid/register',
    element: <VendorRegistration />
  },
  {
    path: '/:state/:township/:uuid/forgot-password',
    element: <ForgotPasswordPage />
  },
  {
    path: '/:state/:township/:uuid/forgot-password/verify-otp',
    element: <OTPVerificationPage />
  },
  {
    path: '/:state/:township/:uuid/forgot-password/reset-password',
    element: <ResetPasswordPage />
  }
];
